// READCT
import React, { Component } from 'react';

// STYLES
import { stretchVideoStyles } from './styles';

// VENDOR COMPONENTS
import Player from '@vimeo/player';

/*
    Receives props from parent:
    - source
    - handleCloseVideo
    - onVideoComplete
*/

export class StretchVideo extends Component {
    constructor(props){
        super(props);
        this.state = {
            constant: this.props.height / this.props.width
        }
    }
        
    handleResize = (e) => {
        this.setState({
            videoHeight: this.refs.iframe.offsetWidth * this.state.constant
        });
    }

    componentDidMount() {
        const self = this;
        window.addEventListener('resize', this.handleResize);
        var videoWidth = this.refs.iframe.offsetWidth;
        var videoHeight = videoWidth * this.state.constant;
        
        var iframeData = document.querySelector('#iframeData');
        var player = new Player(iframeData);
    
        player.on('play', () => {
            console.log('played the video!');
        });

        player.on('ended', () => {
            console.log('ended the video!');
            this.props.handleCloseVideo();
        });

        this.setState({
            videoHeight: videoHeight
        });
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    
    render(){
        const styles = stretchVideoStyles;
        return (
            <iframe id="iframeData" style={ styles.iframe } ref={'iframe'} src={this.props.source} frameBorder="0" height={this.state.videoHeight} allowFullScreen></iframe>
        );
    }
};


// WEBPACK FOOTER //
// ./src/js/components/StretchVideo/StretchVideo.jsx